const updatePaymentType = (_, variables, { cache }) => {
  const { type } = variables;
  const data = {
    configurator: {
      __typename: 'Configurator',
      financeEstimator: {
        __typename: 'Finance Estimator',
        paymentType: type // 'cash' or 'loan'
      }
    }
  };
  cache.writeData({ data });
  return null;
};

export default updatePaymentType;
